import {
  ICallcardButtonEvent,
  ICallcardButtonTool,
  ToolColor,
  ToolExpand,
  ToolFill,
  ToolSize,
  ToolType
} from '@addins/core/singlecallcard';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { Observable, Subject } from 'rxjs';

export class AddAttachmentCardButton implements ICallcardButtonTool {
  private readonly _click = new Subject<ICallcardButtonEvent>();
  get onClick(): Observable<ICallcardButtonEvent> {
    return this._click.asObservable();
  }

  readonly icon: string = 'assets/icons/attachment-icons/add-attachment.svg';
  position: number = 1001;
  show: boolean = false;
  text: string = 'Mobile.AddAttachment';
  dontTranslate: boolean = false;
  type: ToolType;

  color: ToolColor;
  expand: ToolExpand;
  fill: ToolFill;
  size: ToolSize;

  click(card: CallCard): void {
    this._click.next({ target: card });
  }
}
